// extracted by css-extract-rspack-plugin
export default {"content":"PteyW","disabled":"dOT27","smartLink":"sXmAA"};